import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './AboutContent.scss';
import Images from '../../Assets/Images/Images';

const AboutContent = () => {
  return (
    <div className='about'>
      <Container>
        <Row>
          <Col className='about__col'>
            <h2 className='about__title'>Kost Khusus Putri Jakarta Selatan yang Nyaman</h2>
          </Col>
        </Row>
        <Row>
          <Col className='about__col' md={{ span: 6 }}>
            <p className='about__text'>House of Arie menghadirkan tempat tinggal yang dirancang untuk kenyamanan para
              penghuni dengan menghadirkan Kost Khusus Putri yang nyaman dan aman. Terinspirasi oleh energi positif dari
              lingkungan muda, kreatif, dan beragam di kawasan Jakarta Selatan. Ini tercermin dalam desain fungsional
              dan modern yang dilapisi dengan dekorasi dan detail yang hangat. Kami mempromosikan konsep hidup di
              lingkungan yang nyaman dan aman, cocok untuk mahasiswi dan pekerja yang bekerja di daerah metropolitan
              Jakarta.</p>
            <p className='about__text'>Dinamai “House”, House of Arie dimaksudkan sebagai tempat yang bisa membuat orang
              merasa seperti di rumah sendiri.</p>
          </Col>
          <Col className='about__col' md={{ span: 4, offset: 1 }}>
            <img className='about__image' alt='' src={Images.aboutTwo} />
          </Col>
        </Row>
        <Row>
          <Col className='about__col' md={{ span: 4, offset: 1 }}>
            <img className='about__image' alt='' src={Images.aboutTwo} />
          </Col>
          <Col className='about__col' md={{ span: 6, offset: 1 }}>
            <p className='about__text about__text--last'>House of Arie berada di dua tempat yang strategis. Lokasi House
              of Arie 1 ada di Jalan Depsos Gg. H. Mardan No.72. Menghadirkan Kost khusus putri dengan 70 kamar yang
              siap untuk dihuni. House of Arie 2 berada sangat dekat dengan kampus FKG Dr. Moestopo, Jalan Bhakti no. 5
              menghadirkan 48 kamar kost khusus puti yang nyaman.</p>
            <p className='about__text'>Berada di lokasi yang strategis, Jakarta Selatan dekat dengan berbagai kampus
              ternama, pusat kota dan akses jalan tol. Mudah dijangkau transportasi publik seperti TransJakarta dan
              angkutan umum.</p>
            <p className='about__text'>Kami menantikan kunjungan Anda.</p>
          </Col>
        </Row>
        <Row>
          <Col className='about__col' md={6}>
            <img className='about__image' alt='' src={Images.homeHouseOne} />
          </Col>
          <Col className='about__col' md={6}>
            <img className='about__image about__image--last' alt='' src={Images.homeHouseTwo} />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AboutContent;
